<template>
  <section class="tva-intro">
    <div class="background" v-if="progress <= 1.5">
      <div
        class="background-image"
        :style="{
          backgroundImage: `url(${baseUrl}images/C0_img1${$retina ? '@2x' : ''}${$tvaMq === 'mobile' ? '_m' : ''}.jpg)`,
          transform: `${indexIntro > 0 ? 'scale3d(1,1,1)' : 'scale3d(1.4,1.4,1.4)'}`, 
          backgroundPosition: indexIntro > 0 ? '50% 50%' : '50% 140%'
        }"
      ></div>
      <div
        :class="['background-gradient', indexIntro > 0 && indexIntro < 2 ? 'hidden': indexIntro >= 2 ? 'total' : '']"
      ></div>
    </div>

    <Scroller :threshold=".5" v-on:index="indexIntro = $event.value">
      <div ref="foreground" class="first-part">
        <div class="section" id="tva-intro-section-0">
          <div class="line top"></div>
          <div class="landing-title-1">{{$ml.get('landing').number}}</div>
          <h1>{{$ml.get('landing').title}}</h1>
          <div class="landing-subtitle">{{$ml.get('landing').subtitle}}</div>
          <div class="scroll-down" v-if="indexIntro < 1" @click="scrollTo()">
            <div class="scroll-icon"></div>
            <p class="actions">{{$ml.get('landing').scroll}}</p>
          </div>
        </div>
      </div>
    </Scroller>

    <Scroller
      :threshold="1"
      :top="0"
      :bottom="1"
      v-on:index="indexIntro = $event.value"
      v-on:progress="progress = $event.value"
      v-on:offset="offset = $event.value"
      v-on:activeSections="activeSections = $event.value"
      v-on:direction="direction = $event.value"
    >
      <div ref="background" class="second-part-background">
        <transition-group class="second-part-background-wrapper" tag="div" name="fade">
          <div class="second-part-one" v-if="indexIntro === 2" key="fade-0">
            <div class="line top"></div>

            <div class="quote">
              <svgicon class="quote-symbol quote-symbol-top" icon="quote1" height="25" width="25"></svgicon>
              <p class="text-overlay" v-html="$ml.get('landing').quote"></p>
              <p class="text-overlay yellow" v-html="$ml.get('landing').quote_2"></p>
              <svgicon
                class="quote-symbol quote-symbol-bottom"
                icon="quote2"
                height="25"
                width="25"
              ></svgicon>
            </div>

            <div class="line bottom"></div>
          </div>
          <div class="second-part-two" v-if="indexIntro === 3" key="fade-1">
            <div class="line top"></div>

            <div class="quote">
              <svgicon class="quote-symbol quote-symbol-top" icon="quote1" height="25" width="25"></svgicon>
              <p class="text-overlay" v-html="$ml.get('landing').sostenibilita"></p>
              <p class="text-overlay" v-html="$ml.get('landing').quote_3"></p>
              <svgicon
                class="quote-symbol quote-symbol-bottom"
                icon="quote2"
                height="25"
                width="25"
              ></svgicon>
            </div>

            <div class="line bottom"></div>
          </div>
          <div class="second-part-three" :style="{opacity: indexIntro === 4 ? 1 : 0}" key="fade-2">
            <div class="line top">
              <SiriWave :audioPlay="audioPlay"/>
            </div>

            <div class="play-container">
              <p class="text-overlay">{{$ml.get('landing').podcast}}</p>
              <div class="play-button">
                <div
                  :class="['play-button-content', audioPlay ? 'playing' :'']"
                  @click="toggleAudio()"
                >
                  <svgicon class="play" :icon="audioPlay ? 'pause' : 'play'" height="10" width="10"></svgicon>
                </div>
              </div>
              <p class="actions duration">{{audioProgress}} / {{audioDuration}}</p>
              <p class="actions replay" @click="replay()">| Replay</p>
            </div>
            <div class="line bottom">
              <SiriWave :audioPlay="audioPlay"/>
            </div>
          </div>
        </transition-group>
      </div>

      <div ref="foreground" class="second-part">
        <div class="section" id="tva-intro-section-1"></div>
        <div class="section" id="tva-intro-section-2"></div>
        <div class="section" id="tva-intro-section-3"></div>
        <div class="section" id="tva-intro-section-4"></div>
        <div class="section" id="tva-intro-section-5"></div>
      </div>
    </Scroller>
  </section>
</template>

<script>
import Scroller from "../utilities/Scroller.vue";
import { Howl, Howler } from "howler";
import SiriWave from "./SiriWave.vue";
import "@/compiled-icons/play";
import "@/compiled-icons/pause";

export default {
  created() {
    let component = this;
    if (!this.audio) {
      this.audio = new Howl({
        src: [
          `${this.baseUrl}audio/podcast-${this.$ml.current}.ogg`,
          `${this.baseUrl}audio/podcast-${this.$ml.current}.mp3`
        ],
        autoplay: false,
        loop: false,
        html5: true,
        onload: function() {
          component.audioDuration = component.formatTime(this.duration());
        }
      });
      window.setInterval(() => {
        this.audioProgress = this.formatTime(this.audio.seek());
      });
    }
  },
  watch: {
    progress(progress) {
      if (progress > 1) {
        this.pauseAudio();
      }
    },
    indexIntro(indexIntro) {
      if (indexIntro < 4) {
        this.pauseAudio();
      }
    }
  },
  methods: {
    pauseAudio() {
      this.audio.pause();
      this.audioPlay = false;
    },
    toggleAudio() {
      this.audioPlay = !this.audioPlay;

      if (this.audioPlay) {
        if (this.audio) this.audio.play();
      } else {
        if (this.audio) this.audio.pause();
      }
    },
    replay() {
      if (this.audio) {
        this.audio.stop();
        this.audio.play();
        this.audioPlay = true;
      }
    },
    formatTime: function(secs) {
      var minutes = Math.floor(secs / 60) || 0;
      var seconds = secs - minutes * 60 || 0;

      return minutes + ":" + (seconds < 10 ? "0" : "") + seconds.toFixed(0);
    },
    scrollTo() {
      this.$scrollTo(`#tva-intro-section-2`, 800, {
        offset: this.firstLoad ? -window.innerHeight / 3 : 0
      });
      this.firstLoad = false;
    }
  },
  data() {
    return {
      indexIntro: 0,
      progress: 0,
      audio: null,
      audioPlay: false,
      audioDuration: 0,
      audioProgress: 0,
      siriWave: null,
      firstLoad: true,
      baseUrl: process.env.BASE_URL
    };
  },
  components: {
    Scroller,
    SiriWave
  }
};
</script>


<style lang="scss" scoped>
@import "../assets/scss/fonts.scss";
@import "../assets/scss/colors.scss";
@import "../assets/scss/bootstrap-grid.scss";

.tva-intro {
  .background {
    position: fixed;
    top: 49px;
    left: 0;
    width: 100vw;
    height: calc(100vh - 49px);
    z-index: -1;
    .background-image {
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      transition: all 2s ease;
    }
    .background-gradient {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        to top,
        rgba(0, 0, 0, 0.9) 0%,
        rgba(0, 0, 0, 0) 100%
      );
      opacity: 1;
      transition: opacity 1s ease;
      &.hidden {
        opacity: 0;
      }
      &.total {
        background: rgba(0, 0, 0, 0.7);
      }
    }
  }
  .first-part {
    position: relative;
    .section {
      height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      position: relative;
      .line.top {
        width: 1px;
        height: 50%;
        position: absolute;
        top: 0;
        left: 50%;
        background: $eni-yellow;
      }
      .landing-title-1 {
        font-family: "Avenir Next";
        font-size: 160px;
        color: white;
        text-transform: uppercase;
        margin: 0;
        opacity: 0.5;
        font-weight: 800;
        line-height: 130px;
        letter-spacing: 0px;
      }
      .landing-subtitle {
        font-family: "Avenir Next";
        font-size: 32px;
        font-weight: 200;
        letter-spacing: 4px;
        line-height: 0px;
        text-align: center;
        color: $eni-yellow;
      }
    }
    .scroll-down {
      position: fixed;
      width: 200px;
      display: flex;
      flex-direction: column;
      align-items: center;
      bottom: 40px;
      left: calc(50% - 100px);
      z-index: 1;
      cursor: pointer;
      .scroll-icon {
        height: 10px;
        width: 10px;
        border-bottom: solid 1px white;
        border-left: solid 1px white;
        transform: rotate(-45deg);
        margin-bottom: 10px;
      }
    }
  }
  .second-part {
    .section {
      height: 100vh;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:first-of-type {
        height: 50vh;
      }
    }
  }
  .second-part-background {
    width: 100vw;
    height: calc(100vh - 50px);
    margin-top: 50px;
    opacity: 1;
    position: relative;
    .line {
      width: 1px;
      height: 100%;
      background: $eni-yellow;
      z-index: 1;
      &.top {
        top: 0;
      }
      &.bottom {
        bottom: 0;
      }
    }
    .second-part-background-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 1;
      .fade-enter-active,
      .fade-leave-active {
        transition: all 1s;
      }
      .fade-enter,
      .fade-leave-to {
        opacity: 0;
      }
      .fade-enter-to,
      .fade-leave {
        opacity: 1;
      }
      .quote-symbol {
        position: absolute;
        left: calc(50% - 12px);
        fill: $eni-yellow;
        &.quote-symbol-top {
          top: -40px;
        }
        &.quote-symbol-bottom {
          bottom: -40px;
        }
      }
      .second-part-zero,
      .second-part-one,
      .second-part-two,
      .second-part-three {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .quote {
          max-width: 700px;
          margin: 50px 0;
          padding: 30px 0;
          position: relative;
          flex-shrink: 0;
        }
      }
      .second-part-one {
      }
      .second-part-two {
      }
      .second-part-three {
        transition: opacity 1s ease;
        .line.top,
        .line.bottom {
          width: 100px;
          background: transparent;

          display: flex;
          justify-content: center;
          align-items: center;
          position: relative;
        }
        .play-container {
          display: flex;
          flex-direction: column;
          z-index: 1;
          align-items: center;
          flex-shrink: 0;
          .play-button {
            flex-shrink: 0;
            height: 100px;
            width: 100px;
            border-radius: 50%;
            border: solid 1px $eni-yellow;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 30px 0;
            .play-button-content {
              height: 40px;
              width: 40px;
              display: flex;
              align-items: center;
              justify-content: center;
              border: solid 1px $eni-yellow;
              border-radius: 50%;
              cursor: pointer;
              &:hover {
                background: $eni-yellow;
                .svg-icon {
                  fill: #000;
                  stroke: #000;
                }
              }
              &.playing {
              }
              .svg-icon {
                fill: $eni-yellow;
                stroke: $eni-yellow;
              }
            }
          }
          .duration {
            user-select: none;
          }
          .replay {
            padding-left: 4px;
            display: inherit;
            display: flex;
            justify-content: center;
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
}
@media (max-width: 720px) {
  .tva-intro {
    .first-part {
      .section {
        .line.top {
          display: none;
        }
        .landing-title-1 {
          font-size: 110px;
        }
        h1 {
          font-size: 60px;
        }
        .landing-subtitle {
          font-size: 20px;
          font-weight: 500;
        }
      }
    }
    .second-part-background {
      .second-part-background-wrapper {
        .second-part-one,
        .second-part-two {
          .quote {
            padding: 0 10px;
            p {
              font-size: 14px;
              line-height: 17px;
            }
            .svg-icon {
              height: 20px !important;
            }
          }
        }
      }
    }
  }
}
</style>